import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { PoModalModule, PoPageModule, PoWidgetModule, PoFieldModule, PoButtonModule, PoContainerModule, PoLoadingModule, PoTooltipModule, PoSelectOption, PoModalAction, PoModalComponent } from '@po-ui/ng-components';
import { InventoryService } from '../../../shared/service/inventory.service';
import { TokenService } from '../../../shared/service/token.service';
import { InventoryCountCardComponent } from './inventory-count-card/inventory-count-card.component';
import { InventoryCountModel } from '../../../models/inventory-count.model';
import { InventoryModel } from '../../../models/inventory.model';
import { ToasterService } from '../../../shared/service/toaster.service';
import { FixedRoundButtonComponent } from '../../../shared/components/fixed-round-button/fixed-round-button.component';

@Component({
  selector: 'app-inventory-count',
  imports: [FormsModule,
    PoModalModule,
    PoPageModule,
    PoWidgetModule,
    PoFieldModule,
    PoButtonModule,
    PoContainerModule,
    CommonModule,
    PoLoadingModule,
    PoTooltipModule,
    ReactiveFormsModule,
    InventoryCountCardComponent,
    FixedRoundButtonComponent],
  templateUrl: './inventory-count.component.html',
  styleUrl: './inventory-count.component.css'
})
export class InventoryCountComponent {
  @Output() isLoading = new EventEmitter<boolean>();
  @Input() inventoryHeader!: InventoryModel;
  @Output() inventoryCountSelected = new EventEmitter<InventoryCountModel>();
  @ViewChild('poModalNewInventoryCount', { static: false }) poModalNewInventoryCount!: PoModalComponent;
  filterForm!: FormGroup;
  newInventoryCountForm!: FormGroup;
  showNewCountButton = true;
  primaryAction: PoModalAction = {
    action: () => {
      this.showNewCountButton = false;
      this.onSubmitNewInventoryCountForm();
    },
    label: 'Criar',
  };
  secondaryAction: PoModalAction = {
    action: () => {
      this.showNewCountButton = true;
      this.poModalNewInventoryCount.close();
      this.newInventoryCountForm.patchValue({
        inventoryCountDescription: null
      });
    },
    label: 'Cancelar'
  };
  inventoryCounts: InventoryCountModel[] = [];
  statusFilter = '';
  seeFilter: boolean = false;
  fadeInAnimation = false;
  funnelIcon = 'an an-funnel-simple';
  arrowDown = 'an an-arrow-down';
  properties: Array<string> = [];
  readonly statusItens: Array<PoSelectOption> = [
    { label: 'Em Andamento', value: '1' },
    { label: 'Encerrada', value: '5' },
    { label: 'Cancelada', value: '6' },
    { label: 'Agrupada', value: '10' },
  ];

  isNewCountButtonDisabled: boolean = true;

  constructor(
    private inventoryService: InventoryService,
    private tokenService: TokenService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private toasterService: ToasterService,) {

  }
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      inventoryCountCodeFilter: [null],
      inventoryCountStatusFilter: ['1'],
      inventoryCountDescriptionFilter: ['']
    });

    this.newInventoryCountForm = this.fb.group({
      inventoryCountDescription: ['', Validators.required]
    });
  }

  isInventoryCountFormInvalid(): boolean {
    if (this.newInventoryCountForm === undefined) return false;

    return (this.newInventoryCountForm.get('inventoryCountDescription')?.invalid &&
      this.newInventoryCountForm.get('inventoryCountDescription')?.touched) ?? true;
  }

  ngAfterViewInit(): void {
    this.getinventoryCounts();
    this.cdRef.detectChanges();
  }

  getinventoryCounts() {
    this.isInLoad(true);
    const loggedBranchCode = this.tokenService.getBranch();
    const inventoryCountCodeParam = this.filterForm.get('inventoryCountCodeFilter')?.value;
    const inventoryCountStatusFilterParam = this.filterForm.get('inventoryCountStatusFilter')?.value;
    const inventoryCountDescriptionParam = this.filterForm.get('inventoryCountDescriptionFilter')?.value;

    this.inventoryService.getInventoryCountList(Number(loggedBranchCode), Number(inventoryCountStatusFilterParam), this.inventoryHeader.inventoryCode, isNaN(inventoryCountCodeParam) ? null : inventoryCountCodeParam, inventoryCountDescriptionParam).subscribe({
      next: (data: any) => {
        this.inventoryCounts = data.items;
        this.executeFadeInAnimation();
      },
      complete: () => {
        this.isInLoad(false);
      }, error: () => {
        this.isInLoad(false);
        this.inventoryCounts = [];
      }
    });
  }

  isInLoad(value: boolean) {
    this.isNewCountButtonDisabled = value;
    this.loading(value);
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  onSeeFilter() {
    this.seeFilter = !this.seeFilter;
  }

  executeFadeInAnimation() {
    this.fadeInAnimation = false;
    setTimeout(() => {
      this.fadeInAnimation = true;
    }, 10);
  }

  recoverStatusSelected(event: any) {
    this.statusFilter = event;
  }

  onFilter() {
    this.filterForm.markAllAsTouched();
    this.filterForm.updateValueAndValidity();

    if (this.filterForm.invalid) {
      this.filterForm.markAllAsTouched();
      return;
    }

    this.getinventoryCounts();
  }

  cleanFilter() {
    this.filterForm.patchValue({
      inventoryCountCodeFilter: '',
      inventoryCountDescriptionFilter: ''
    });

    this.getinventoryCounts();
  }

  onInventoryCountSelected(item: InventoryCountModel) {
    this.inventoryCountSelected.emit(item);
  }

  newInventoryCount() {
    if (this.isNewCountButtonDisabled) return;
    this.isInLoad(true);
    const loggedBranchCode = this.tokenService.getBranch();
    const inventoryCountDescriptionParam = (this.newInventoryCountForm.get('inventoryCountDescription')?.value ?? '') as string;
    this.inventoryService.createInventoryCount(Number(loggedBranchCode), this.inventoryHeader.inventoryCode, inventoryCountDescriptionParam)
      .subscribe({
        next: (data) => {
          this.onInventoryCountSelected(data);
        },
        complete: () => {
          this.isInLoad(false);
        }, error: () => {
          this.isInLoad(false);
          this.toasterService.triggerAlert(`Não foi possível criar a contagem para o balanço ${this.inventoryHeader.inventoryCode}`, 'error');
        }
      });

  }

  openModalNewInventoryCount() {
    this.showNewCountButton = false;
    this.poModalNewInventoryCount.open();
  }

  onSubmitNewInventoryCountForm() {
    this.newInventoryCountForm.markAllAsTouched();
    this.newInventoryCountForm.updateValueAndValidity();

    if (this.newInventoryCountForm.invalid) {
      this.newInventoryCountForm.markAllAsTouched();
      this.newInventoryCountForm.get('inventoryCountDescription')?.updateValueAndValidity();
      return;
    }

    this.poModalNewInventoryCount.close();
    this.showNewCountButton = true;
    this.newInventoryCount();
  }
}
